import React,{useState} from "react";
import { format_date } from "../../../../utils/date_format";
import { MdEdit } from "react-icons/md";
import { useSelector } from "react-redux";
import { getPlatformImg } from "../../../../helpers/getImgSrc";

const CampaignHeaderCard = ({
  campaign_name,
  status,
  start_date,
  end_date,
  created_at,
  setCampaignId,
  setShow,
  campaign_id,
  userList,
  ads_platform_status,
}) => {
  const user = useSelector((state) => state?.user);
  const [brokenImages, setBrokenImages] = useState({});





  return (
    <div className="px-4 pb-4">
      <div className="row campaign_sub_card  ">
        <div className="col-md-3 col-6 d-flex  justify-content-between flex-column">
          <p className="mb-0 text_color_secondary">
            {campaign_name ? campaign_name : "_ _ _ _ _ _ _ _"}
            {!user?.is_super_admin && (
              <span
                onClick={() => {
                  if (campaign_id) {
                    setCampaignId(campaign_id);
                    setShow(true);
                    //setProgramDetails()
                  }
                }}
                className="pe-auto"
                style={{ cursor: "pointer" }}
              >
                <MdEdit className="fs-6 ms-2" />
              </span>
            )}
          </p>
          <span>
            Created {created_at ? format_date(created_at) : "00.00.00"}
          </span>
        </div>
        <div className="col-md-3 col-6 d-flex flex-column align-items-end mb-sm-2 mb-md-0 align-items-md-start  justify-content-between flex-column ">
          <div className="mb-0.7 d-flex gap-1">
            {!Object.values(ads_platform_status)?.some(
              (status) => status === 1 || status === true
            ) ? (
              <span className="text-muted">---</span>
            ) : (
              <>
                {ads_platform_status?.google_active ? (
                  <img src={getPlatformImg(1)} alt="Google" />
                ) : null}
                {ads_platform_status?.linkedin_active ? (
                  <img src={getPlatformImg(2)} alt="LinkedIn" />
                ) : null}
                {ads_platform_status?.snapchat_active ? (
                  <img src={getPlatformImg(3)} alt="LinkedIn" />
                ) : null}
                {ads_platform_status?.spotify_active ? (
                  <img src={getPlatformImg(4)} alt="Spotify" />
                ) : null}
                {ads_platform_status?.facebook_active ? (
                  <img src={getPlatformImg(6)} alt="Facebook Ads" />
                ) : null}
                 {ads_platform_status?.instagram_active ? (
                  <img src={getPlatformImg(7)} alt="Instagram Ads" />
                ) : null}
              </>
            )}
          </div>
          <span>Currently running within</span>
        </div>
        <div className="col-md-6 row d-flex align-items-center ">
          <div className="col-lg-3 col-md-3 col-3 d-flex align-items-center justify-content-between flex-column gap-2">
            <p className="campaign_sub_card_badge badge_3 mb-0 rounded-pill py-1  ">
              {status.toUpperCase()}
            </p>
            <span>Status</span>
          </div>
          <div className="col-lg-3  col-md-4 col-4 d-flex align-items-center justify-content-between flex-column gap-2">
            <p className="mb-0 date">
              {start_date ? format_date(start_date) : "00.00.00"}
            </p>
            <span>Start Date</span>
          </div>
          <div className="col-lg-3  col-md-4 col-4 d-flex align-items-center justify-content-between flex-column gap-2">
            <p className="mb-0 date">
              {end_date ? format_date(end_date) : "00.00.00"}
            </p>
            <span>End Date</span>
          </div>
          <div className="col-lg-3 col-md-4 col-4 d-flex  justify-content-between flex-column gap-2">
            <div className="campaign_team_member d-flex align-items-center  position-relative  my-2">
              {userList?.map((user, index) => {
                const showImage = user?.profile_image && !brokenImages[user?.user_id];
                return (
                  <div
                    key={user?.user_id}
                    title={`${user?.first_name} ${user?.last_name}`}
                    style={{
                      height: "24px",
                      borderRadius: "50%",
                      marginLeft: `${index}.9rem`,
                      zIndex: 99,
                      cursor: "pointer",
                    }}
                    className="position-absolute d-flex justify-content-center align-items-center  px-1 py-0.5"
                  >
                    {showImage ? (
                      <img
                        src={user?.profile_image}
                        onError={() => {
                          setBrokenImages((prev)=>({...prev,[user?.user_id]:true}))
                        }}
                        className="img-fluid "
                        alt={`${user?.first_name} ${user?.last_name}`}
                        srcSet=""
                        style={{ marginLeft: "0.7rem" }}
                      />
                    ) : (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          width: "27px",
                          height: "27px",
                          marginLeft: "0.7rem",
                          backgroundColor: "#EEDBFF",
                          borderRadius: "50%",
                        }}
                      >
                        <p
                          className="mb-0"
                          style={{
                            fontSize: "10px",
                            color: "#7F56D9",
                            fontFamily: "aeonik_bold",
                          }}
                        >
                          {user?.first_name[0].toUpperCase()}
                          {user?.last_name[0].toUpperCase()}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
            <span className=" text-center pt-1">Team members</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignHeaderCard;
